import type { Theme } from '@mui/material/styles'

type Owner = { theme: Theme }

const Dialog = () => ({
  MuiDialog: {
    styleOverrides: {
      paper: ({ theme }: Owner) => ({
        boxShadow: theme.shadows[6],
        '&:not(.MuiDialog-paperFullScreen)': {
          borderRadius: 8,
          [theme.breakpoints.down('sm')]: {
            margin: theme.spacing(4),
            width: `calc(100% - ${theme.spacing(8)})`,
            maxWidth: `calc(100% - ${theme.spacing(8)}) !important`,
          },
        },
        '& > .MuiList-root': {
          paddingLeft: theme.spacing(1),
          paddingRight: theme.spacing(1),
        },
      }),
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: ({ theme }: Owner) => ({
        padding: theme.spacing(6, 6, 1),
        '& + .MuiDialogContent-root': { paddingTop: `${theme.spacing(6)} !important` },
      }),
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: ({ theme }: Owner) => ({
        padding: theme.spacing(6),
        '& + .MuiDialogContent-root': { paddingTop: '0 !important' },
        '& + .MuiDialogActions-root': { paddingTop: '0 !important' },
      }),
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: ({ theme }: Owner) => ({ padding: theme.spacing(1, 6, 6) }),
    },
  },
})

export default Dialog
